module.exports = __webpack_public_path__ + "img/eye.850b0047.svg";